import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Toolbar from "@mui/material/Toolbar";

import MaterialBox from "../../../../components/MaterialBox";
import { setMiniSidenav, setTransparentNavbar, useMaterialUIController } from "../../../../context";
import { navbarContainer, navbar, navbarRow } from "./styles";
import Breadcrumbs from "./components/Breadcrumbs";
import NotificationItem from "./components/NotificationItem";
import MaterialAvatar from "../../../../components/MaterialAvatar";
import { Avatar, Box, Stack, Typography } from "@mui/material";
import stringAvatar from "../../../../functions/stringAvatar";
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import MaterialTypography from "../../../../components/MaterialTypography";
import axios from "axios";
import { useSnackbar } from "../../../../context/popup";

function DashboardNavbar({ absolute, light, isMini }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const route = useLocation().pathname.split("/").slice(1);
  const [user, setUser] = useState({
    name: "Ajith Kumar",
    picture: "",
    email: ""
  });
  const [pageState, setPageState] = useState({
    state: 'init'
  });

  useEffect(() => {
    const getUser = () => {
      setUser({
        name: user.name,
        email: user.email,
        picture: user.picture
      })
      setPageState({
        state: 'default'
      })
    }
    getUser()
  }, [])

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const open = Boolean(openMenu)
  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}

    >
      <NotificationItem icon={
        <>
          {
            user.picture ?
              <Avatar alt={user.name} src={user.picture} sx={{ width: 24, height: 24 }} />
              :
              <MaterialAvatar
                size="sm"
                {
                ...stringAvatar(user.name || user.email || "UNNAMED")
                }
              />
          }
        </>
      } title={user.name || user.email} />
      <NotificationItem id="logout" onClick={signOut} icon={<LogoutIcon />} title={"Logout"} />
    </Menu>
  );

      const signOut = async (navigate) => {

      try {

        // 1️⃣ Get token

        const token = sessionStorage.getItem('token')
    
        if (!token) {

          throw new Error('No token found for logout')

        }
    
        // 2️⃣ Call Logout API

        const response = await axios.post(process.env.REACT_APP_LOGOUT_API_BASE_URL,

          {},

          {

            headers: {

              'Content-Type': 'application/json',

              Authorization: `Bearer ${token}`

            }

          }

        )
    
        const data = response.data
    
        if (data?.success === false) {

          showSnackbar(data.message || 'Logout API call failed',"error")

          return

        }
    
        showSnackbar(data.message || 'Logged out successfully',"success");
    
        // ⏳ Delay for UX

        setTimeout(async () => {

          // 3️⃣ Clear storage

          sessionStorage.clear()

          localStorage.clear()
    
          // 4️⃣ Clear cookies

          document.cookie.split(';').forEach(cookie => {

            document.cookie = cookie

              .replace(/^ +/, '')

              .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`)

          })
    
          // 5️⃣ Clear cache (PWA / SW)

          if ('caches' in window) {

            const cacheNames = await caches.keys()

            await Promise.all(cacheNames.map(name => caches.delete(name)))

          }
    
          // 6️⃣ HARD redirect (kills memory + cache)

          window.location.replace(process.env.REACT_APP_APP_URL ||
              '/'
          )

        }, 500)

      } catch (error) {

        console.error('Logout failed:', error)
        showSnackbar(error.message || 'Something went wrong during logout',"error");
      }

    }

 

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      // position="navbarType"
      color="inherit"
      // sx={(theme) => navbar(theme, { transparentNavbar, absolute, light })}
      sx={{
        borderRadius: 0,
        // background: "radial-gradient(circle at center, rgba(167,174,214,0.6) 0%, rgba(167,174,214,0.4) 30%, rgba(255,255,255,1) 100%)",
        backdropFilter: "blur(10px)",              // glass blur effect
        WebkitBackdropFilter: "blur(10px)",        // Safari support
        // boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",// subtle shadow
        // border: "1px solid rgba(255, 255, 255, 0.2)" // frosted border
      }}
    >
      <Toolbar minHeight='10px !important' sx={(theme) => navbarContainer(theme)}>
        {
          pageState.state === 'default' && (
            <>
              <MaterialBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}  >
                <MaterialBox display="flex">
                  <Icon fontSize="medium" onClick={handleMiniSidenav} sx={{ cursor: "pointer", color: "white" }}>
                    {miniSidenav ? <MenuOpenIcon /> : <MenuIcon />}
                  </Icon>
                  <MaterialBox ml={1}>
                    <Breadcrumbs icon={<HomeIcon />} title={route[route.length - 1]} route={route} light={light} />
                  </MaterialBox>
                </MaterialBox>
              </MaterialBox>
              {/* {isMini ? null : (
                <MaterialBox sx={(theme) => navbarRow(theme, { isMini })}>
                  <IconButton
                    onClick={handleOpenMenu}
                    size="small"
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                  >
                    <MaterialAvatar alt={user.name} src={user.picture} sx={{ width: 30, height: 30 }} />
                  </IconButton>
                  {renderMenu()}
                </MaterialBox>
              )} */}

              <MaterialBox sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: 1
              }}>
                <IconButton>
                  <SettingsIcon sx={{ color: "#2d4080" }} />
                </IconButton>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    height: 45,
                    backgroundColor: "#0d1b5e",
                    color: "white",
                    borderRadius: "40px 40px 0px 40px",
                    // padding: "8px 16px",
                    width: "fit-content",
                    cursor: "pointer"
                  }}
                  onClick={handleOpenMenu}
                >
                  <Avatar
                    src="https://i.pravatar.cc/150?img=3"
                    alt="Bala"
                    sx={{ width: 40, height: 40, marginRight: 2 }}
                  />

                  <Stack direction="column" sx={{ marginRight: 1 }}>
                    <MaterialTypography variant="h6" color="white">
                      Ajith Kumar
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="white">Super Admin</MaterialTypography>
                  </Stack>
                </Box>
                {/* <IconButton>
                  <LogoutIcon />
                </IconButton> */}
                {renderMenu()}
              </MaterialBox>
            </>
          )
        }
      </Toolbar>
    </AppBar>
  );
}

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
